import { getBody, getFlags } from "./armor-system-4JVSZEDO.js";

// src/util/PortalToBody.tsx
import React, { useContext } from "react";
import { createPortal } from "react-dom";
var PortalContext = React.createContext({
  enabled: true
});
var valueDisabled = {
  enabled: false
};
var globalFlags = getFlags();
var PortalToBody = function PortalToBody(_ref) {
  var children = _ref.children,
    enablePortal = _ref.enablePortal;
  var body = getBody();
  var portalContextValue = useContext(PortalContext);
  if (!enablePortal || !body || globalFlags.enablePortal === false || (portalContextValue == null ? void 0 : portalContextValue.enabled) === false) {
    return /* @__PURE__ */React.createElement(React.Fragment, null, children);
  }
  return createPortal(children, body);
};
PortalToBody.defaultProps = {
  enablePortal: true
};
var DisablePortal = function DisablePortal(_ref2) {
  var children = _ref2.children;
  return /* @__PURE__ */React.createElement(PortalContext.Provider, {
    value: valueDisabled
  }, children);
};
export { PortalToBody, DisablePortal };